import { useDialog } from "../shared/useDialog";
import { backdropClose } from "../shared/backdrop";

export function ConfirmDialog({
  title, message, confirmLabel = "Confirmar", danger, onConfirm, onCancel,
}: {
  title: string;
  message?: string;
  confirmLabel?: string;
  danger?: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}) {
  const dialogRef = useDialog(onCancel);
  return (
    <div
      {...backdropClose(() => { onCancel(); })}
      style={{
        position: "fixed", inset: 0, background: "var(--overlay)", zIndex: "calc(var(--z-modal) + 100)" as any,
        display: "flex", alignItems: "center", justifyContent: "center",
      }}
    >
      <div ref={dialogRef} role="alertdialog" aria-modal="true" aria-label={title} tabIndex={-1} style={{ background: "var(--surface-card)", boxShadow: "var(--shadow-modal)", border: "1px solid var(--line-strong)", borderRadius: 10, padding: 20, width: 360, maxWidth: "calc(100vw - 32px)", display: "flex", flexDirection: "column", gap: 12, outline: "none", animation: "panel-in 0.18s var(--ease-out-quint)" }}>
        <span style={{ fontSize: 14, fontWeight: 600, color: "var(--ink)" }}>{title}</span>
        {message && <span style={{ fontSize: 12, color: "var(--ink-secondary)", lineHeight: 1.5 }}>{message}</span>}
        <div style={{ display: "flex", gap: 8, justifyContent: "flex-end" }}>
          <button
            type="button"
            onClick={onCancel}
            style={{ background: "none", color: "var(--ink-secondary)", border: "1px solid var(--line-strong)", borderRadius: 8, padding: "7px 14px", fontSize: 13, cursor: "pointer" }}
          >
            Cancelar
          </button>
          <button
            type="button"
            onClick={onConfirm}
            style={{ background: danger ? "var(--brand)" : "var(--violet)", color: "#fff", border: "none", borderRadius: 8, padding: "7px 14px", fontSize: 13, cursor: "pointer" }}
          >
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
}
